export var US_STATES = [[0, "", ""], [3524, "Alaska", "AK"], [3525, "Alabama", "AL"], [3526, "Arkansas", "AR"], [3528, "Arizona", "AZ"], [3529, "California", "CA"], [3530, "Colorado", "CO"], [3531, "Connecticut", "CT"], [3532, "District of Columbia", "DC"], [3533, "Delaware", "DE"], [3534, "Florida", "FL"], [3535, "Georgia", "GA"], [3537, "Hawaii", "HI"], [3538, "Iowa", "IA"], [3539, "Idaho", "ID"], [3540, "Illinois", "IL"], [3541, "Indiana", "IN"], [3542, "Kansas", "KS"], [3543, "Kentucky", "KY"], [3544, "Louisiana", "LA"], [3545, "Massachusetts", "MA"], [3546, "Maryland", "MD"], [3547, "Maine", "ME"], [3548, "Michigan", "MI"], [3549, "Minnesota", "MN"], [3550, "Missouri", "MO"], [3552, "Mississippi", "MS"], [3553, "Montana", "MT"], [3554, "North Carolina", "NC"], [3555, "North Dakota", "ND"], [3556, "Nebraska", "NE"], [3557, "New Hampshire", "NH"], [3558, "New Jersey", "NJ"], [3559, "New Mexico", "NM"], [3560, "Nevada", "NV"], [3561, "New York", "NY"], [3562, "Ohio", "OH"], [3563, "Oklahoma", "OK"], [3564, "Oregon", "OR"], [3565, "Pennsylvania", "PA"], [3567, "Rhode Island", "RI"], [3568, "South Carolina", "SC"], [3569, "South Dakota", "SD"], [3570, "Tennessee", "TN"], [3571, "Texas", "TX"], [3573, "Utah", "UT"], [3574, "Virginia", "VA"], [3576, "Vermont", "VT"], [3577, "Washington", "WA"], [3578, "Wisconsin", "WI"], [3579, "West Virginia", "WV"], [3580, "Wyoming", "WY"]];
export var usStates = US_STATES.map(function (a) {
  return {
    id: a[0],
    value: a[0],
    text: a[1] || " "
  };
});
export var stateNameToAbbreviation = {
  Alaska: "AK",
  Alabama: "AL",
  Arkansas: "AR",
  Arizona: "AZ",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  "District of Columbia": "DC",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Iowa: "IA",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Massachusetts: "MA",
  Maryland: "MD",
  Maine: "ME",
  Michigan: "MI",
  Minnesota: "MN",
  Missouri: "MO",
  Mississippi: "MS",
  Montana: "MT",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Nebraska: "NE",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  Nevada: "NV",
  "New York": "NY",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Virginia: "VA",
  Vermont: "VT",
  Washington: "WA",
  Wisconsin: "WI",
  "West Virginia": "WV",
  Wyoming: "WY"
};
export var stateAbbreviationToNames = {
  AK: "Alaska",
  AL: "Alabama",
  AR: "Arkansas",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  IA: "Iowa",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  MA: "Massachusetts",
  MD: "Maryland",
  ME: "Maine",
  MI: "Michigan",
  MN: "Minnesota",
  MO: "Missouri",
  MS: "Mississippi",
  MT: "Montana",
  NC: "North Carolina",
  ND: "North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VA: "Virginia",
  VT: "Vermont",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming"
};
export var stateZipcodeConstrains = {
  3525: {
    range: [35e3, 36999]
  },
  3524: {
    range: [99500, 99999]
  },
  3528: {
    range: [85e3, 86999]
  },
  3526: {
    range: [71600, 72999]
  },
  3529: {
    range: [9e4, 96699]
  },
  3530: {
    range: [8e4, 81999]
  },
  3531: {
    range: [6e3, 6389, 6391, 6999]
  },
  3533: {
    range: [19700, 19999]
  },
  3534: {
    range: [32e3, 34999]
  },
  3535: {
    range: [3e4, 31999, 39800, 39999]
  },
  3537: {
    range: [96700, 96999]
  },
  3539: {
    range: [83200, 83999]
  },
  3540: {
    range: [6e4, 62999]
  },
  3541: {
    range: [46e3, 47999]
  },
  3538: {
    range: [5e4, 52999]
  },
  3542: {
    range: [66e3, 67999]
  },
  3543: {
    range: [4e4, 42999]
  },
  3544: {
    range: [7e4, 71599]
  },
  3547: {
    range: [3900, 4999]
  },
  3546: {
    range: [20600, 21999]
  },
  3545: {
    range: [1e3, 2799],
    match: [5501, 5544]
  },
  3548: {
    range: [48e3, 49999]
  },
  3549: {
    range: [55e3, 56899]
  },
  3552: {
    range: [38600, 39999]
  },
  2550: {
    range: [63e3, 65999]
  },
  3553: {
    range: [59e3, 59999]
  },
  3554: {
    range: [27e3, 28999]
  },
  3555: {
    range: [58e3, 58999]
  },
  3556: {
    range: [68e3, 69999]
  },
  3560: {
    range: [88900, 89999]
  },
  3557: {
    range: [3e3, 3899]
  },
  3558: {
    range: [7e3, 8999]
  },
  3559: {
    range: [87e3, 88499]
  },
  3561: {
    range: [1e4, 14999],
    match: [6390, 501, 544]
  },
  3562: {
    range: [43e3, 45999]
  },
  3563: {
    range: [73e3, 73199, 73400, 74999]
  },
  3564: {
    range: [97e3, 97999]
  },
  3565: {
    range: [15e3, 19699]
  },
  3567: {
    range: [2800, 2999]
  },
  3568: {
    range: [29e3, 29999]
  },
  3569: {
    range: [57e3, 57999]
  },
  3570: {
    range: [37e3, 38599]
  },
  3571: {
    range: [75e3, 79999, 73301, 73399, 88500, 88599]
  },
  3573: {
    range: [84e3, 84999]
  },
  3576: {
    range: [5e3, 5999]
  },
  3574: {
    range: [20100, 20199, 22e3, 24699],
    match: [20598]
  },
  3532: {
    range: [2e4, 20099, 20200, 20599, 56900, 56999]
  },
  3577: {
    range: [98e3, 99499]
  },
  3579: {
    range: [24700, 26999]
  },
  3578: {
    range: [53e3, 54999]
  },
  3580: {
    range: [82e3, 83199]
  }
};